// Tiles for the platform's deployed parts, drawn like the Scout app tiles on
// the Client tab: a white glyph on the tile blue, corners a quarter of the size.

import {
  BookOpenIcon,
  CloudIcon,
  ComputerDesktopIcon,
  CpuChipIcon,
  GlobeAsiaAustraliaIcon,
  MapIcon,
  ServerStackIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';
import { APP_TILE_BLUE, appIconRadius } from './AppIcon';

const GLYPH: Record<string, typeof ServerStackIcon> = {
  api: ServerStackIcon,
  portal: ComputerDesktopIcon,
  track: GlobeAsiaAustraliaIcon,
  passagewiki: BookOpenIcon,
  router: MapIcon,
  routing: CpuChipIcon,
  weather: CloudIcon,
  cdn: Squares2X2Icon,
};

/** A part's tile at `size` px. Decorative: show the name beside it. */
export function PartIcon({ part, size }: { part: string; size: number }) {
  const Glyph = GLYPH[part] ?? ServerStackIcon;
  const glyph = Math.round(size * 0.6);
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size, borderRadius: appIconRadius(size), background: APP_TILE_BLUE }}
      className="inline-flex flex-none items-center justify-center"
    >
      <Glyph width={glyph} height={glyph} strokeWidth={1.7} className="text-white" />
    </span>
  );
}
